import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {moduloVMI} from '../../../diccionarios/moduloVMI';
import {VmiArticulosService} from '../../../services/administracion/vmi-articulos.service';
import {AG_GRID_LOCALE_ES} from '../../../diccionarios/spanishAgGrid';
import {NucleoModel} from '../../../models/vmi-nucleoModel';
import {ClienteModel} from '../../../models/vmi-clienteModel';
import {VmiClientesService} from '../../../services/administracion/vmi-clientes.service';
import {ArticuloModel} from '../../../models/vmi-articuloModel';
import {VmiPenetracionService} from '../../../services/informes/vmi-penetracion.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

@Component({
  selector: 'app-vmi-reporte-penetracion-clasico',
  templateUrl: './vmi-reporte-penetracion-clasico.component.html',
  styleUrls: ['./vmi-reporte-penetracion-clasico.component.css']
})
export class VmiReportePenetracionClasicoComponent implements OnInit {

  formulario: FormGroup;
  modulo: any = {};
  DAT_TITULOS: any;
  titulo: any;
  AG_GRID_LOCALE_ES: any = {};

  loading: boolean = false;
  loading2: boolean = false;
  cmbCliente: ClienteModel[] = [];
  cmbArticulo: ArticuloModel[] = [];

  lista: NucleoModel[];
  fechaInicio: string;

  listVmiStockfisico: number[] = []
  listVmiPorcpenetracionreal: number[] = [];
  listVmiFechaReg: string[] = [];

  listVmiAmortverde: number[] = [];
  listVmiAmortamarillo: number[] = [];
  listVmiAmortrojo: number[] = [];
  listaVacia: boolean = true;

  columnDefs: any[];
  rowData: NucleoModel[] = [];
  simple: NucleoModel[] = [];
  complex: NucleoModel[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;

  headerHeight = 150;

  imagenB64:string = "";

  isInventarioDetallado: boolean = false;

  constructor(
    private _penetracion: VmiPenetracionService,
    private _cliente: VmiClientesService,
    private _articulo: VmiArticulosService,
    private _utils: UtilsService,
    private fb: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this.modulo = moduloVMI;
    this.AG_GRID_LOCALE_ES = AG_GRID_LOCALE_ES;
    this.DAT_TITULOS = this.modulo.titulos.penetracion;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.formulario = this.fb.group({
      fechaFinal: ['', [Validators.required]],
      cliente: ['', [Validators.required]],
      articulo: ['', [Validators.required]]
    });
    this.getAllCliente();
    this.gridComponent();
    this.formulario.get('fechaFinal').setValue(this._utils.getCurrentDateGuion());
  }

  gridComponent() {
    if (this.isInventarioDetallado === false) {
      this.columnDefs = [
        {
          headerName: 'No',
          field: 'vmiId',
          sortable: true,
          filter: true,
          width: 120
        },
        {
          headerName: 'FECHA',
          field: 'vmiFecha',
          sortable: true,
          filter: true,
          width: 150,
          valueGetter: function (data) {
            return data.data.vmiFecha.substring(0, 10);
          }
        },
        {
          headerName: 'HORA',
          field: 'vmiHora',
          sortable: true,
          filter: true,
          width: 130
        },
        {
          headerName: 'AMORTIGUADOR',
          field: 'vmiAmortiguador',
          sortable: true,
          filter: true,
          width: 160
        },
        {
          headerName: 'STOCK ANTERIOR',
          field: 'vmiStockAnterior',
          sortable: true,
          filter: true,
          width: 180
        },
        {
          headerName: 'STOCK FÍSICO',
          field: 'vmiStockfisico',
          sortable: true,
          filter: true,
          width: 160
        },
        {
          headerName: '%PENETRACIÓN REAL',
          field: 'vmiPorcpenetracionreal',
          sortable: true,
          filter: true,
          width: 200
        },
        {
          headerName: 'CONSUMO STOCK',
          field: 'vmiStockDespachar',
          sortable: true,
          filter: true,
          width: 180
        },
        {
          headerName: 'DEFERENCIA',
          sortable: true,
          filter: true,
          width: 180,
          valueGetter: function (data) {
            let vmiStockAnterior = data.data.vmiStockAnterior;
            let vmiStockfisico = data.data.vmiStockfisico;
            return Number((vmiStockAnterior - vmiStockfisico).toFixed(2));
          }
        }
      ];
    } else {
      
      this.columnDefs.push(
        {
          headerName: 'FECHA INGRESO',
          field: 'vmiFechaReg',
          sortable: true,
          filter: true,
          width: 200
        }
      );
    
    }
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = 'multiple';
  }

  getInvetarioDetallado() {
    this.rowData = [];
    this.rowData = this.complex;
    console.log('inventario detallado');
    this.isInventarioDetallado = true;
    this.gridComponent();
    this.listaVacia = true;
    setTimeout(() => {
      this.listaVacia = false;
    }, 100);
  }

  notInvetarioDetallado() {
    this.rowData = [];
    this.rowData = this.simple;
    console.log('not inventario detallado');
    this.isInventarioDetallado = false;
    this.gridComponent();
    setTimeout(() => {
      this.listaVacia = false;
    }, 100);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  //*SERVICIOS
  getPenetracionFiltrado() {
    this.loading2 = true;
    this.loading = true;
    this.listaVacia = true;
    this.complex = [];
    this.simple = [];
    this._penetracion.getPenetracionCrudoLegado(
      this.formulario.get('cliente').value,
      this.formulario.get('articulo').value,
      this.fechaInicio,
      this.formulario.get('fechaFinal').value
    ).subscribe((res: any[]) => {
      this.loading2 = false;
      console.log(res);
      this.complex = res.map(e => {
        e.vmiAmortiguador = Number(e.vmiAmortiguador.toFixed(2));
        e.vmiStockAnterior = Number(e.vmiStockAnterior.toFixed(2));
        e.vmiStockfisico = Number(e.vmiStockfisico.toFixed(2));
        e.vmiPorcpenetracionreal = Number(e.vmiPorcpenetracionreal.toFixed(2));
        e.vmiStockDespachar = Number(e.vmiStockDespachar.toFixed(2));
        return e;
      });
      if(this.isInventarioDetallado){
        this.rowData = this.complex;
      }
      //
      /*this.lista = res;
      this.rowData = res.map(e => {
        e.vmiAmortiguador = Number(e.vmiAmortiguador.toFixed(2));
        e.vmiStockAnterior = Number(e.vmiStockAnterior.toFixed(2));
        e.vmiStockfisico = Number(e.vmiStockfisico.toFixed(2));
        e.vmiPorcpenetracionreal = Number(e.vmiPorcpenetracionreal.toFixed(2));
        e.vmiStockDespachar = Number(e.vmiStockDespachar.toFixed(2));
        return e;
      });
      this.rowData.sort((a, b) => b.vmiId - a.vmiId);
      this.listaVacia = res.length === 0 ? true : false;
      //*CREACION DE BARRAS, LINEA DE PENETRACION Y COLORES DE AMORTIGUADOR
      this.listVmiFechaReg = res.map(e => e.vmiFechaReg.substring(0, 10));
      this.listVmiStockfisico = res.map(e => Number(e.vmiStockfisico.toFixed(2)));
      this.listVmiPorcpenetracionreal = res.map(e => Number(e.vmiPorcpenetracionreal.toFixed(2)));
      this.listVmiAmortverde = res.map(e => e.vmiAmortverde);
      this.listVmiAmortamarillo = res.map(e => e.vmiAmortamarillo);
      this.listVmiAmortrojo = res.map(e => e.vmiAmortrojo);
      setTimeout(() => {
        this.loading = false;
      }, 1000);*/
    }, (err) => {
      console.log(err);
      this.loading2 = false;
      /*this.lista = [];
      this.loading = false;
      this.listaVacia = true;
      this._utils.mensajeErroToast(err.error.mensaje);*/
    });
    this._penetracion.getPenetracionFiltradoLegado(
      this.formulario.get('cliente').value,
      this.formulario.get('articulo').value,
      this.fechaInicio,
      this.formulario.get('fechaFinal').value
    ).subscribe((res: any[]) => {
      this.lista = res;
      this.simple = res.map(e => {
        e.vmiAmortiguador = Number(e.vmiAmortiguador.toFixed(2));
        e.vmiStockAnterior = Number(e.vmiStockAnterior.toFixed(2));
        e.vmiStockfisico = Number(e.vmiStockfisico.toFixed(2));
        e.vmiPorcpenetracionreal = Number(e.vmiPorcpenetracionreal.toFixed(2));
        e.vmiStockDespachar = Number(e.vmiStockDespachar.toFixed(2));
        return e;
      });
      this.simple = this.simple.sort((a, b) => (b.vmiFecha).localeCompare(a.vmiFecha) );
      if(!this.isInventarioDetallado){
        this.rowData = this.simple;
      }
      //this.rowData.sort((a, b) => (b.vmiFecha).localeCompare(a.vmiFecha) );
      this.listaVacia = res.length === 0 ? true : false;
      //*CREACION DE BARRAS, LINEA DE PENETRACION Y COLORES DE AMORTIGUADOR
      this.listVmiFechaReg = res.map(e => e.vmiFechaReg.substring(0, 10));
      this.listVmiStockfisico = res.map(e => Number(e.vmiStockfisico.toFixed(2)));
      this.listVmiPorcpenetracionreal = res.map(e => Number(e.vmiPorcpenetracionreal.toFixed(2)));
      this.listVmiAmortverde = res.map(e => e.vmiAmortverde);
      this.listVmiAmortamarillo = res.map(e => e.vmiAmortamarillo);
      this.listVmiAmortrojo = res.map(e => e.vmiAmortrojo);
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    }, (err) => {
      console.log(err);
      this.lista = [];
      this.loading = false;
      this.listaVacia = true;
      this._utils.mensajeErroToast(err.error.mensaje);
    });

    this._penetracion.getPenetracionFiltradoImagenLegado(
      this.formulario.get('cliente').value,
      this.formulario.get('articulo').value,
      this.fechaInicio,
      this.formulario.get('fechaFinal').value
    ).subscribe((res: any[]) => {
      this.imagenB64 = "data:image/jpeg;base64,"+res;

    }, (err) => {
      console.log(err);
      this._utils.mensajeErroToast(err.error.mensaje);
    });
  }

  getAllCliente() {
    this._cliente.getAllLoged().subscribe((res: ClienteModel[]) => {
      this.cmbCliente = res;
      if(res.length>0){
        this.formulario.get('cliente').setValue(res[0].cliId);
        this.getArticuloByCliente();
      }
    }, (err) => {
      this.cmbCliente = [];
    });
  }

  getArticuloByCliente() {
    this._articulo.getArticuloByCliente(this.formulario.get('cliente').value).subscribe((res: ArticuloModel[]) => {
      this.cmbArticulo = res;
      if(res.length>0){
        this.formulario.get('articulo').setValue(res[0].artId);
      }
    }, (err) => {
      this.cmbArticulo = [];
    });
  }

  buscar() {
    const fechaFinal = this.formulario.get('fechaFinal').value;
    const date = new Date(fechaFinal);
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let mnth1 = ("0" + (date.getMonth())).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    let fechaFin = [date.getFullYear(), mnth, day].join("-");
    this.fechaInicio = [date.getFullYear(), mnth1, day].join("-");
    this.getPenetracionFiltrado();
  }

  generarPdf(){
      this.loading = true;
      this._penetracion.getPenetracionFiltradoPdf(
        this.formulario.get('cliente').value,
        this.formulario.get('articulo').value,
        this.formulario.get('fechaFinal').value
      ).subscribe((res: any) => {
        this.loading = false;
        console.log(res);
        this._utils.descargarArchivoV2(this.formulario.get('cliente').value+'_'+
        this.formulario.get('articulo').value+'_'+this.formulario.get('fechaFinal').value,res,"pdf");
      }, (err) => {
        this.loading = false;
        console.log(err);
        this._utils.mensajeErroToast(err.error.mensaje);
      });
      //this._utils.descargarArchivoV2("Documento","Base64","Pdf");
  }

}
